import React, { useCallback, useMemo } from 'react';
import { Card, CardContent, CardHeader, Chip, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { useOnlineDeviceApi, useOnlineDeviceIds, useOnlineDeviceState } from '../live/online-device-provider';
import { topicBuilder, useMqttListener } from '../../../devices';
import { useTranslation } from 'react-i18next';

export const useLastStateListener = (serialNumber, cb) => {
    const [lastUpdate, setLastUpdate] = React.useState(null);
    const listener = useCallback((data) => {
        cb(data);
        setLastUpdate(new Date());
    }, [cb]);
    const topic = useMemo(() => topicBuilder(`v1/dev/${serialNumber}/d/connection`), [serialNumber]);
    useMqttListener(topic, listener);
    return lastUpdate;
}

export default function LastStateCard({ ...props }) {
    const { t } = useTranslation();
    const { serialNumber } = useOnlineDeviceIds();
    const { setState } = useOnlineDeviceApi();
    const { state, modelNumber, firmwareRevision, hardwareRevision } = useOnlineDeviceState();

    const lastUpdate = useLastStateListener(serialNumber, setState);

    return (
        <Card {...props}>
            <CardHeader title={t('DEVICES.DETAILS.STATUS_CARD.TITLE')} subheader={serialNumber} />
            <CardContent>
                <Table size='small'>
                    <TableBody>
                        <TableRow>
                            <TableCell>{t('DEVICES.DETAILS.STATUS_CARD.STATE')}</TableCell>
                            <TableCell>{state === 'connected' ?
                                <Chip label='connected' color='success' /> :
                                <Chip label='disconnected' variant='outlined' />}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{t('DEVICES.DETAILS.STATUS_CARD.MODEL')}</TableCell>
                            <TableCell><Typography>{modelNumber}</Typography></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{t('DEVICES.DETAILS.STATUS_CARD.FIRMWARE')}</TableCell>
                            <TableCell><Typography>{firmwareRevision}</Typography></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{t('DEVICES.DETAILS.STATUS_CARD.HARDWARE')}</TableCell>
                            <TableCell><Typography>{hardwareRevision}</Typography></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>{t('DEVICES.DETAILS.STATUS_CARD.LAST_UPDATE')}</TableCell>
                            <TableCell><Typography>{lastUpdate?.toLocaleTimeString()}</Typography></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        </Card>

    )
}

LastStateCard.propTypes = {

}